var _g, _ellipse, _rect, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCitizenmarkernew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 52,
    viewBox: "0 0 48 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9218_353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.02 44.2417C22.5236 44.2417 22.0272 44.1545 21.5308 43.9799C21.0343 43.8053 20.5911 43.5435 20.2011 43.1944C17.8963 41.0997 15.8574 39.0574 14.0845 37.0674C12.3116 35.0774 10.8312 33.1486 9.64335 31.2808C8.45549 29.413 7.5513 27.6151 6.93078 25.887C6.31026 24.1588 6 22.5093 6 20.9382C6 15.7015 7.71087 11.5296 11.1326 8.42242C14.5543 5.31529 18.5168 3.76172 23.02 3.76172C27.5232 3.76172 31.4857 5.31529 34.9074 8.42242C38.3291 11.5296 40.04 15.7015 40.04 20.9382C40.04 22.5093 39.7298 24.1588 39.1092 25.887C38.4887 27.6151 37.5845 29.413 36.3967 31.2808C35.2088 33.1486 33.7284 35.0774 31.9555 37.0674C30.1826 39.0574 28.1437 41.0997 25.8389 43.1944C25.4489 43.5435 25.0057 43.8053 24.5093 43.9799C24.0128 44.1545 23.5164 44.2417 23.02 44.2417ZM23.02 24.7087C24.1901 24.7087 25.1918 24.2985 26.0251 23.4781C26.8584 22.6576 27.275 21.6714 27.275 20.5193C27.275 19.3672 26.8584 18.381 26.0251 17.5605C25.1918 16.7401 24.1901 16.3299 23.02 16.3299C21.8499 16.3299 20.8482 16.7401 20.0149 17.5605C19.1816 18.381 18.765 19.3672 18.765 20.5193C18.765 21.6714 19.1816 22.6576 20.0149 23.4781C20.8482 24.2985 21.8499 24.7087 23.02 24.7087Z",
    fill: "#003460"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.4606,
    cy: 21.2389,
    rx: 7.82,
    ry: 7.36,
    fill: "#003460"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_9218_353)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9218_353",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 7,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 7,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9218_353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 19C21.9 19 20.9583 18.6083 20.175 17.825C19.3917 17.0417 19 16.1 19 15C19 13.9 19.3917 12.9583 20.175 12.175C20.9583 11.3917 21.9 11 23 11C24.1 11 25.0417 11.3917 25.825 12.175C26.6083 12.9583 27 13.9 27 15C27 16.1 26.6083 17.0417 25.825 17.825C25.0417 18.6083 24.1 19 23 19ZM15 25V24.2C15 23.6333 15.1458 23.1125 15.4375 22.6375C15.7292 22.1625 16.1167 21.8 16.6 21.55C17.6333 21.0333 18.6833 20.6458 19.75 20.3875C20.8167 20.1292 21.9 20 23 20C24.1 20 25.1833 20.1292 26.25 20.3875C27.3167 20.6458 28.3667 21.0333 29.4 21.55C29.8833 21.8 30.2708 22.1625 30.5625 22.6375C30.8542 23.1125 31 23.6333 31 24.2V25C31 25.55 30.8042 26.0208 30.4125 26.4125C30.0208 26.8042 29.55 27 29 27H17C16.45 27 15.9792 26.8042 15.5875 26.4125C15.1958 26.0208 15 25.55 15 25Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9218_353",
    x: 3,
    y: 0.761719,
    width: 44.0391,
    height: 50.4805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9218_353"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9218_353",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_9218_353",
    x: 9,
    y: 5,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9218_353"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9218_353",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitizenmarkernew);
export default __webpack_public_path__ + "static/media/citizenmarkernew.6bc261f433ea3aff9832dd99e05dccdb.svg";
export { ForwardRef as ReactComponent };